module.exports = __webpack_public_path__ + "static/Octopus_Giant-236979c26f958c3565ab6853461197fe.jpg";